<template>
  <div class="container-fluid">
    <Add
      :toggleAdd="toggleAdd"
      :installationList="installationList"
      :addOffCanvas="addOffCanvas"
      :getSubs="getSubs"
    />
    <Edit
      :toggleEdit="toggleEdit"
      :installationList="installationList"
      :editOffCanvas="editOffCanvas"
      :getSubs="getSubs"
      :form="form"
    />

    <div class="col-xl-12 col-lg-12 col-md-12">
      <div
        class="page-content__header-description"
        style="display: flex; margin-bottom: 20px"
      >
        <h2 style="flex: 1">Subscription Management</h2>
      </div>
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12">
          <div class="container-fluid">
            <can I="create" a="subsmanager">
              <div class="flex" style="display: flex; flex-flow: row-reverse">
                <el-button
                  style
                  type="prim​​ary"
                  class="customer-btn"
                  @click="toggleAdd"
                  >Add</el-button
                >&nbsp;
                <!--                <el-button-->
                <!--                  style="background: rgb(26, 147, 202); color: white"-->
                <!--                  type="success"-->
                <!--                  class="customer-btn success"-->
                <!--                  @click="sendIvoices"-->
                <!--                  :disabled="loadingSend"-->
                <!--                  plain-->
                <!--                  >{{ loadingSend ? "Loading..." : "Send Invoices" }}</el-button-->
                <!--                >-->
                <!-- <el-button
                  style="background: #424242; color: white"
                  type="prim​​ary"
                  class="customer-btn primary"
                  @click="sendReminder"
                  :disabled="loadingReminder"
                  >{{
                    loadingReminder ? "Loading..." : "Send Reminder"
                  }}</el-button
                > -->
              </div>
            </can>
            <div>
              <div>
                <vue-good-table
                  @on-selected-rows-change="selectionChanged"
                  :columns="columns"
                  :rows="subs"
                  @on-row-click="onRowClick"
                  :row-style-class="rowStyleClassFn"
                  :select-options="{
                    enabled: true,
                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                    selectionInfoClass: 'custom-class',
                    selectionText: 'rows selected',
                    clearSelectionText: 'clear',
                    disableSelectInfo: true, // disable the select info panel on top
                    selectAllByGroup: true // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
                  }"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { HTTP as IOTHTTP } from "@/store/actions";
import { mapGetters, mapActions } from "vuex";
import Add from "./add";
import Edit from "./edit";
import moment from "moment";
export default {
  name: "device-chart",
  props: {},
  components: {
    Add,
    Edit
  },
  computed: {
    ...mapGetters(["getUserSession"])
  },
  data: function() {
    return {
      addOffCanvas: false,
      editOffCanvas: false,
      previewOffCanvas: false,
      loadingSend: false,
      loadingReminder: false,
      selectedRow: null,
      installationList: [],
      form: {
        user: {
          address: ""
        },
        installation: null,
        filterDate: [],
        sendDate: ""
      },
      columns: [
        {
          label: "ID",
          field: "uid"
        },
        {
          label: "First Name",
          field: "firstName"
        },
        {
          label: "Last Name",
          field: "lastName"
        },
        {
          label: "Email",
          field: "email"
        },
        {
          label: "Payment Model",
          field: "paymentModel"
        },
        {
          label: "Amount (#)",
          field: "amountString",
          type: "number"
        },
        {
          label: "Billing Period",
          field: "billingPeriod",
          type: "string"
        },
        {
          label: "is Billing Period updated",
          field: "isBillingUpdated",
          type: "boolean",
          hidden: true
        }
      ], //isBillingUpdated
      subs: []
    };
  },
  methods: {
    selectionChanged(e) {
      if (e.selectedRows.length <= 0) return (this.selectedRow = null);
      let obj = e.selectedRows;
      let data = Object.keys(obj).map(key => obj[key].id);
      this.selectedRow = data;
      if (data.length <= 0) return (this.selectedRow = null);
      this.selectedRow = data;
      console.log(this.selectedRow);
    },
    rowStyleClassFn(row) {
      return row.isBillingUpdated ? "green-border" : "red-border";
    },
    toggleAdd() {
      let ctx = this;
      ctx.addOffCanvas = !ctx.addOffCanvas;
    },
    toggleEdit() {
      let ctx = this;
      ctx.editOffCanvas = !ctx.editOffCanvas;
    },
    togglePreview() {
      let ctx = this;
      ctx.previewOffCanvas = !ctx.previewOffCanvas;
    },
    onRowClick(params) {
      let ctx = this;
      console.log({ row: params.row });
      //  this.removeComma(params.row.amount);
      ctx.form = params.row;
      // ctx.form.amount=this.removeComma(params.row.amount);
      ctx.toggleEdit();
    },
    removeComma(val) {
      if (val != "" && val != null && typeof val != "undefined") {
        return parseFloat(val.replace(/,/g, "")).toFixed(2);
      } else {
        return "";
      }
    },
    getContacts() {
      const HTTP = this.$httpUtils.instance;
      let ctx = this;
      let filter = {
        where: {
          and: [
            { CID: { neq: null } },
            {
              or: [
                { status: "requested" },
                { status: "scheduled" },
                { status: "commissioned" },
                { status: "completed" }
              ]
            }
          ]
        },
        include: ["deviceRequest", "locations", "user"]
      };
      const url = `/installations?filter=${JSON.stringify(filter)}`;
      HTTP.get(url)
        .then(response => {
          ctx.installationList = response.data.map(x => ({
            ...x,
            value:
              x && x.deviceRequest
                ? `${x.name} (${x.CID ? x.CID : x.solarKitIds}) `
                : null
          }));
        })
        .catch(error => {
          console.log("error", error);
        });
    },
    sendReminder() {
      try {
        let ctx = this;
        const HTTP = ctx.$httpUtils.instance;
        ctx.loadingReminder = true;
        const url = `/subscriptionsMgr/autoMonthlySubsReminderRe_sender/${this.getUserSession.id}`;
        HTTP.post(url)
          .then(response => {
            ctx.loadingReminder = false;
            console.log({ response });
            alert("sent");
          })
          .catch(error => {
            let { response } = error;
            ctx.loadingReminder = false;
            console.error({
              error: error.response
                ? error.response.status == 422
                  ? error.response.data.error.message
                  : error.response
                : null
            });
            let errMsg = error.response
              ? error.response.status == 422
                ? error.response.data.error.message
                : error.response
              : null;
            console.log({ tttttt: response });
            if (response.status == 422) {
            } else alert(response.data.error.message);
          });
      } catch (error) {}
      return;
    },
    async sendIvoices() {
      let ctx = this;
      const HTTP = ctx.$httpUtils.instance;

      const url = `/subscriptionsMgr/autoMonthlySubsReminder/${this.getUserSession.id}`;
      let userId = this.getUserSession.id;
      console.log({ subs: this.subs });

      let subs = this.subs;
      let status = await subs.reduce((status = true, v) => {
        if (!v.isBillingUpdated) {
          status = v.isBillingUpdated;
        }
        return status;
      }, true);
      if (!status) {
        alert("One or more records billing period are months behind.");
      } else {
        ctx.loadingSend = true;
        HTTP.post(url)
          .then(response => {
            ctx.loadingSend = false;
            console.log({ response });
            alert("sent");
          })
          .catch(error => {
            ctx.loadingSend = false;
            let { response } = error;
            if (response && response.status == 400) {
              alert(response.data.error.message);
            }
            console.log({ error });
          });
      }
    },
    numberWithCommas(val) {
      if (val != "" && val != null && typeof val != "undefined") {
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return "";
      }
    },

    getSubs() {
      let ctx = this;
      const HTTP = ctx.$httpUtils.instance;

      const url = `/subscriptionsMgr`;
      HTTP.get(url)
        .then(response => {
          ctx.subs = response.data.map((x, i) => ({
            ...x,
            uid: ++i,
            installation: `${x.user.firstName} ${x.user.lastName} (${x.CID})`,
            firstName: x.user.firstName,
            lastName: x.user.lastName,
            email: x.user.email,
            billingPeriod: `${moment(x.filterDate[0]).format(
              "YYYY-MM-DD"
            )} - ${moment(x.filterDate[1]).format("YYYY-MM-DD")}`,
            isBillingUpdated:
              moment(x.filterDate[1]) < moment(new Date()).startOf("month")
                ? false
                : true,
            amountString: this.numberWithCommas(parseFloat(x.amount).toFixed(2))
          }));
          console.log({ subs: ctx.subs });
        })
        .catch(error => {
          console.log("error", error);
        });
    }
  },
  created() {
    let ctx = this;
    ctx.getSubs();
    ctx.getContacts();
  }
};
</script>
<style>
.green-border {
  border: 2pt green solid !important;
}
.red-border {
  border: 2pt red solid !important;
}

.vgt-responsive {
  overflow-x: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/subsmanager/index.vue